import React, { forwardRef } from 'react';

import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import PropTypes from 'prop-types';
import { makeStyles } from 'tss-react/mui';
import noop from 'lodash/noop';
import styles from './MobileTopbar.styles';

const useStyles = makeStyles()(styles);

const MobileTopbar = forwardRef((props, ref) => {
    const { onToggleSidebar = noop } = props;
    const { classes } = useStyles(undefined, {
        props,
    });

    return (
        <header ref={ref} className={classes.root}>
            <IconButton
                className={classes.menuButton}
                onClick={onToggleSidebar}
                size="large"
                aria-label="Open navigation"
            >
                <MenuIcon />
            </IconButton>
        </header>
    );
});

MobileTopbar.displayName = 'MobileTopbar';

MobileTopbar.propTypes = {
    onToggleSidebar: PropTypes.func,
};

export default MobileTopbar;
